function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { arrowSize, StyledArrow } from './OverlayArrow.styles';
export var Arrow = /*#__PURE__*/React.forwardRef(function Arrow(_ref, ref) {
  var _arrow$x, _arrow$y;
  var placement = _ref.placement,
    arrow = _ref.arrow;
  var staticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
  }[placement.split('-')[0]];
  var arrowX = (_arrow$x = arrow === null || arrow === void 0 ? void 0 : arrow.x) !== null && _arrow$x !== void 0 ? _arrow$x : null;
  var arrowY = (_arrow$y = arrow === null || arrow === void 0 ? void 0 : arrow.y) !== null && _arrow$y !== void 0 ? _arrow$y : null;
  return /*#__PURE__*/React.createElement(StyledArrow, {
    ref: ref,
    style: _defineProperty({
      position: 'absolute',
      left: arrowX !== null ? "".concat(arrowX, "px") : undefined,
      top: arrowY !== null ? "".concat(arrowY, "px") : undefined,
      right: '',
      bottom: ''
    }, staticSide, "-".concat(arrowSize / 2, "px")),
    "data-overlay-arrow": true
  });
});
//# sourceMappingURL=OverlayArrow.js.map